export default "__VITE_ASSET__BvTECEWs__"